export default class HeroImage {


    constructor(el, setting) {
        this.$el = el;
        this.$setting = {
            menuShow: false,
            breakpoint: 576
        };
        this.init(this.$el);
    }

    init(heroImageWrap) {
        let heroImage = heroImageWrap ? heroImageWrap.querySelector('img') : false;
        heroImage ? this.mobileImage(heroImage) : false;

    }

    mobileImage(el) {
        this.swapImage(el);
    }

    swapImage(el) {
        let vm = this;
        if (el.dataset.src) {
            let mobileImage = new Image();
            mobileImage.src = el.dataset.src;
            mobileImage.classList.add('mobile-image');

            changeImage();

            window.addEventListener('resize', function(event) {
                changeImage();
            });


            function changeImage() {
                if (window.innerWidth <= vm.$setting.breakpoint) {
                    el.classList.add('d-none');
                    el.parentElement.appendChild(mobileImage);
                } else {
                    el.classList.remove('d-none');
                }
            }
        }

    }

}